<template>
   <!-- @ts-ignore -->
  <v-snackbar
    absolute
    app
    bottom
    tile
    timeout="-1"
    content-class="mx-5 pa-0 body-1 hide-selection-highlight"
    :height="($attrs.height ?? DEFAULT_SNACKBAR_HEIGHT) as string"
    :width="DEFAULT_SNACKBAR_WIDTH"
    v-bind="$attrs"
    :color="($attrs.color ?? 'black') as string"
    :style="{ bottom: bottom ? '-20px' : 0 }"
    transition="slide-y-reverse-transition"
  >
    <slot />
  </v-snackbar>
</template>
<script setup lang="ts">
import { defineProps } from 'vue'
import { VSnackbar } from 'vuetify/components'
import { DEFAULT_SNACKBAR_HEIGHT, DEFAULT_SNACKBAR_WIDTH } from '@/utils/constants/ui-constants'

defineProps<{
  bottom?: boolean
}>()
</script>
